import type { GetDisbursementWithdrawalRequestsParams } from 'api';

import type { GlobalFiltersState } from 'reduxLocal/slices/globalFiltersSlice';

import type { LocalState } from './localState';

export type Params = LocalState &
  GlobalFiltersState & { organisationId: string };

export const apiParams = function (
  state: Partial<Params>
): GetDisbursementWithdrawalRequestsParams {
  const filter: any = {};

  // Apply filters if they exist
  if (
    state.filters?.debtorAccountNumber &&
    state.filters.debtorAccountNumber !== 'All'
  ) {
    filter.debtor_account_number = state.filters.debtorAccountNumber;
  }
  if (state.filters?.status?.trim() && state.filters.status !== 'All') {
    filter.status = state.filters.status;
  }
  if (state.filters?.reference?.trim() && state.filters.reference !== 'All') {
    filter.reference = state.filters.reference;
  }

  // Build pagination params
  const pageParams = {
    ...(state.cursorBefore && { cursor_before: state.cursorBefore }),
    ...(state.cursorAfter && { cursor_after: state.cursorAfter })
  };

  // Build sorting params
  const sortingParams = state.sorting?.trim() ? { sort: state.sorting } : {};

  // Build date range params
  const dateRangeParams = {
    ...(state.dateRange?.from && { created_after: state.dateRange.from }),
    ...(state.dateRange?.to && { created_before: state.dateRange.to })
  };

  // Combine all parameters
  const params: GetDisbursementWithdrawalRequestsParams = {
    ...(Object.keys(pageParams).length > 0 && { page: pageParams }),
    ...sortingParams,
    ...dateRangeParams,
    ...(Object.keys(filter).length > 0 && { filter })
  };

  return params;
};
